import {Component, Output, EventEmitter, Input, OnInit} from '@angular/core';

@Component({
    selector: 'close-btn',
    templateUrl: './close-btn.component.html',
    styleUrls: ['./close-btn.component.css']
})
export class CloseBtnComponent implements OnInit{

    constructor(){
        this.close = new EventEmitter<boolean>();
        this.inputClass = {};
    }

    @Output() private readonly close: EventEmitter<boolean>;
    @Input() private readonly inClass?: string[];
    public readonly inputClass: {[index: string]: boolean};

    ngOnInit(){
        this.generateClass();
    }

    private generateClass = (): any =>{
        this.inClass && this.inClass.length ? this.inClass.forEach(item => this.inputClass[item] = true) : null;
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/close-btn.component/close-btn.component.ts